/** @format */

(function () {
  'use strict';

  rangeTypeFactory.$inject = ["defineEnum"];
  angular.module('student.shared').factory('RangeType', rangeTypeFactory);
  function rangeTypeFactory(defineEnum) {
    return defineEnum(['ONE', 'EXACTLY', 'MAX', 'BETWEEN', 'MIN']);
  }
})();